<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useMessageContext } from '../provider.js';
import BaseBubble from './Base.vue';
import FileIcon from 'next/icon/FileIcon.vue';
import Icon from 'next/icon/Icon.vue';

const { attachments } = useMessageContext();

const { t } = useI18n();

const url = computed(() => {
  return attachments.value[0].dataUrl;
});

const fileName = computed(() => {
  if (url.value) {
    const filename = url.value.substring(url.value.lastIndexOf('/') + 1);
    return filename || t('CONVERSATION.UNKNOWN_FILE_TYPE');
  }
  return t('CONVERSATION.UNKNOWN_FILE_TYPE');
});

const displayName = computed(() => {
  const decoded = decodeURI(fileName.value);
  // Truncate long filenames but keep extension
  if (decoded.length > 30) {
    const ext = decoded.split('.').pop();
    return `${decoded.substring(0, 25)}...${ext}`;
  }
  return decoded;
});

const fileType = computed(() => {
  return fileName.value.split('.').pop();
});
</script>

<template>
  <BaseBubble class="overflow-hidden p-3" data-bubble-name="file">
    <a
      :href="url"
      rel="noreferrer noopener nofollow"
      target="_blank"
      class="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-n-alpha-black1 hover:bg-n-alpha-2 transition-colors min-w-48"
    >
      <FileIcon :file-type="fileType" class="size-5 shrink-0" />
      <span class="text-sm truncate flex-1">{{ displayName }}</span>
      <Icon icon="i-lucide-download" class="size-4 shrink-0 opacity-60" />
    </a>
  </BaseBubble>
</template>
